
import { supabase } from '@/integrations/supabase/client';

/**
 * Helper function to get source names in batch
 */
export const getSourceNamesInBatch = async (procurements: any[]): Promise<Record<string, string | null>> => {
  const sourceMap: Record<string, string | null> = {};
  
  // Group by source type with proper typing
  const groupedSources = procurements.reduce<Record<string, string[]>>((acc, proc) => {
    if (!proc.source_id || !proc.source_type) return acc;
    
    if (!acc[proc.source_type]) acc[proc.source_type] = [];
    acc[proc.source_type].push(proc.source_id);
    return acc;
  }, {});

  // Batch fetch for each source type
  const promises = Object.entries(groupedSources).map(async ([sourceType, ids]) => {
    try {
      const stringIds = ids.filter((id): id is string => typeof id === 'string');
      
      if (stringIds.length === 0) return;
      
      switch (sourceType) {
        case 'farm': {
          const { data } = await supabase
            .from('farms')
            .select('id, farmer_name')
            .in('id', stringIds);
          
          data?.forEach(item => sourceMap[item.id] = item.farmer_name);
          break;
        }
        
        case 'supplier': {
          const { data } = await supabase
            .from('suppliers')
            .select('id, name')
            .in('id', stringIds);
          
          data?.forEach(item => sourceMap[item.id] = item.name);
          break;
        }
        
        case 'agent': {
          const { data } = await supabase
            .from('agents')
            .select('id, name')
            .in('id', stringIds);
          
          data?.forEach(item => sourceMap[item.id] = item.name);
          break;
        }
        
        case 'harvest': {
          const { data } = await supabase
            .from('harvests')
            .select('id, farms(farmer_name)')
            .in('id', stringIds);
          
          data?.forEach(item => {
            if (item.farms?.farmer_name) {
              sourceMap[item.id] = item.farms.farmer_name;
            }
          });
          break;
        }
      }
    } catch (error) {
      console.error(`Error fetching ${sourceType} names:`, error);
    }
  });

  await Promise.all(promises);
  return sourceMap;
};
